/**
 * Report Web Vitals
 * 
 * 報告 Web Vitals 性能指標到分析服務
 */

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
      // 使用新的 Web Vitals API（v3+）
      const sendToAnalytics = (metric) => {
        // 發送到分析服務
        sendToAllAnalytics(metric);
        // 調用自定義回調
        onPerfEntry(metric);
      };
      
      onCLS(sendToAnalytics);
      onFID(sendToAnalytics);
      onFCP(sendToAnalytics);
      onLCP(sendToAnalytics);
      onTTFB(sendToAnalytics);
      // INP (Interaction to Next Paint) 替代 FID
      if (onINP) {
        onINP(sendToAnalytics);
      }
    });
  } else {
    // 即使沒有自定義回調，也發送到分析服務
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
      onCLS(sendToAllAnalytics);
      onFID(sendToAllAnalytics);
      onFCP(sendToAllAnalytics);
      onLCP(sendToAllAnalytics);
      onTTFB(sendToAllAnalytics);
      if (onINP) {
        onINP(sendToAllAnalytics);
      }
    });
  }
};

/**
 * 發送 Web Vitals 數據到所有配置的分析服務
 */
function sendToAllAnalytics(metric) {
  // 發送到 Google Analytics 4
  const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  if (GA4_MEASUREMENT_ID) {
    // 使用 window.gtag 直接發送（react-ga4 會自動初始化 gtag）
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', metric.name, {
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
        // 發送詳細信息
        metric_id: metric.id,
        metric_value: metric.value,
        metric_delta: metric.delta,
        metric_rating: metric.rating,
      });
    } else {
      // 如果 gtag 還沒加載，等待一下再試（最多等待 1 秒）
      let attempts = 0;
      const maxAttempts = 10;
      const checkInterval = setInterval(() => {
        attempts++;
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('event', metric.name, {
            value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
            event_label: metric.id,
            non_interaction: true,
            metric_id: metric.id,
            metric_value: metric.value,
            metric_delta: metric.delta,
            metric_rating: metric.rating,
          });
          clearInterval(checkInterval);
        } else if (attempts >= maxAttempts) {
          // 超過最大嘗試次數，放棄發送
          clearInterval(checkInterval);
        }
      }, 100);
      
      // 1 秒後清除 interval（安全措施）
      setTimeout(() => clearInterval(checkInterval), 1000);
    }
  }

  // 發送到 PostHog
  const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
  if (POSTHOG_API_KEY) {
    import('posthog-js').then((posthog) => {
      if (posthog.__loaded) {
        posthog.capture('web_vital', {
          name: metric.name,
          value: metric.value,
          delta: metric.delta,
          id: metric.id,
          rating: metric.rating,
        });
      }
    }).catch((err) => {
      console.warn('Failed to send Web Vitals to PostHog:', err);
    });
  }

  // 發送到 Sentry（性能監控）
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
  if (SENTRY_DSN && process.env.NODE_ENV === 'production') {
    import('@sentry/react').then((Sentry) => {
      Sentry.metrics.distribution(metric.name, metric.value, {
        unit: metric.name === 'CLS' ? 'ratio' : 'millisecond',
        tags: {
          rating: metric.rating,
        },
      });
    }).catch((err) => {
      console.warn('Failed to send Web Vitals to Sentry:', err);
    });
  }

}

export default reportWebVitals;

